import tracking from 'tracking';

export default {
  init: function (selector) {
    const trackingEvents = document.querySelectorAll(selector);

    if (trackingEvents && trackingEvents.length) {
      [...trackingEvents].map(item => {
        const eventName = item.getAttribute('data-tracking-event') || '';
        const eventType = item.getAttribute('data-tracking-type') || '';
        const eventParams = tracking.getTrackingParams(item);

        if (eventType && eventName) {
          item.addEventListener(eventType, () => tracking.trackingEvent(eventName, eventParams), false);
        }
      });
    }
  }
};
